/* ========================================================================
 * Flexible Content - Legacy
 *
 * JS for legacy ACF flexible_content layouts ported from uavionix-theme.
 * All initializers are gated on .fc-wrapper-legacy presence so they no-op
 * on pages that don't use the legacy template.
 *
 * Removal: delete this file and the import in main.js when the legacy
 * port is retired.
 * ======================================================================== */

import $ from 'jquery';
import UIkit from 'uikit';
import SimpleLightbox from 'simplelightbox';

(function ($) {
  $(function () {
    // -----------------------------------------------------------------
    // Page banner dismiss (legacy banner sits above .fc-wrapper-legacy
    // and outside the dispatcher, so it gets its own gate)
    // -----------------------------------------------------------------
    $('.legacy-page-banner-wrapper .banner-hide').on('click', function () {
      $(this).closest('.legacy-page-banner-wrapper').slideUp(200);
    });

    // -----------------------------------------------------------------
    // Sticky sub-header (legacy): anchor nav collapses into a panel under
    // the bar below 1024px, opened by the page title. The CSS drew the
    // chevron but nothing ever toggled .active, so it never opened.
    // -----------------------------------------------------------------
    (function () {
      var BREAKPOINT = 1024;
      var subHeader = document.querySelector('.legacy-sub-header');
      if (!subHeader) return;

      var title = subHeader.querySelector('.page-title');
      var anchors = subHeader.querySelector('.product-marketing--navigation');
      if (!title) return;

      if (!anchors) {
        title.classList.add('has-no-anchors');
        return;
      }

      var isMobile = function () {
        return window.matchMedia('(max-width: ' + BREAKPOINT + 'px)').matches;
      };

      var close = function () {
        title.classList.remove('active');
        anchors.classList.remove('active');
        title.setAttribute('aria-expanded', 'false');
      };

      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', 'false');

      title.addEventListener('click', function (e) {
        // Breadcrumb links inside the title still navigate.
        if (e.target.closest('a') || !isMobile()) return;

        var open = !title.classList.contains('active');
        title.classList.toggle('active', open);
        anchors.classList.toggle('active', open);
        title.setAttribute('aria-expanded', String(open));
      });

      title.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        if (e.target.closest('a') || !isMobile()) return;
        e.preventDefault();
        title.click();
      });

      // Jumping to an anchor, tapping outside, or growing past the
      // breakpoint all put the bar back to its resting state.
      anchors.addEventListener('click', function (e) {
        if (e.target.closest('a')) close();
      });

      document.addEventListener('click', function (e) {
        if (!subHeader.contains(e.target)) close();
      });

      window.addEventListener('resize', function () {
        if (!isMobile()) close();
      }, { passive: true });
    })();

    // -----------------------------------------------------------------
    // Sticky sub-header (legacy): tap-open the Buy Now product dropdown,
    // which is otherwise hover-only and unreachable on touch.
    // -----------------------------------------------------------------
    document.querySelectorAll('.legacy-sub-header .purchase-menu__dropdown').forEach(function (item) {
      var trigger = item.querySelector(':scope > a');
      if (!trigger) return;

      trigger.addEventListener('click', function (e) {
        // Placeholder href="#" — the anchor only exists to open the list.
        e.preventDefault();
        item.classList.toggle('active');
      });

      document.addEventListener('click', function (e) {
        if (!item.contains(e.target)) item.classList.remove('active');
      });
    });

    // -----------------------------------------------------------------
    // Home hero scroll-fade (legacy, sits outside .fc-wrapper-legacy)
    // -----------------------------------------------------------------
    var heroWrapper = document.querySelector('.legacy-home-hero-content-wrapper');
    if (heroWrapper) {
      var triggerPoint = heroWrapper.offsetHeight * 0.1;
      window.addEventListener('scroll', function () {
        if (window.scrollY > triggerPoint) {
          heroWrapper.classList.add('scrolled');
        } else {
          heroWrapper.classList.remove('scrolled');
        }
      }, { passive: true });
    }

    if (!document.querySelector('.fc-wrapper-legacy')) {
      return;
    }

    // -----------------------------------------------------------------
    // Custom (non-Slick) prev/next carousel
    // -----------------------------------------------------------------
    $('.fc-wrapper-legacy .legacy-carousel').each(function () {
      var $carousel = $(this);
      var $track = $carousel.find('.legacy-carousel-track');
      var $prev = $carousel.find('.legacy-carousel-prev');
      var $next = $carousel.find('.legacy-carousel-next');

      function step() {
        var slide = $track.find('.legacy-carousel-slide').first();
        return slide.outerWidth(true) || $track.width();
      }

      $prev.on('click', function () { $track.animate({ scrollLeft: $track.scrollLeft() - step() }, 300); });
      $next.on('click', function () { $track.animate({ scrollLeft: $track.scrollLeft() + step() }, 300); });
    });

    // -----------------------------------------------------------------
    // UIKit slider for the legacy content carousel
    //
    // Replaces an earlier Slick implementation that overflowed the
    // container. UIKit's uk-slider component handles overflow, slide
    // wraparound (`finite: false`), and prev/next via the
    // `uk-slider-item="previous|next"` attribute — declared in the
    // partial's markup. All we need to do here is wire the slide-index
    // counter to the slider's `itemshown` event.
    // -----------------------------------------------------------------
    $('.fc-wrapper-legacy .legacy-content-carousel .content-carousel-slides[uk-slider]').each(function () {
      var sliderEl    = this;
      var $wrapper    = $(this).closest('.legacy-content-carousel');
      var $slideIndex = $wrapper.find('.slide-index');
      var totalSlides = sliderEl.querySelectorAll('.uk-slider-items > li').length;

      function updateIndex() {
        var component = UIkit.getComponent(sliderEl, 'slider');
        var current   = (component && typeof component.index === 'number') ? component.index : 0;
        $slideIndex.text((current + 1) + ' / ' + totalSlides);
      }

      // Initial value once UIkit has finished init.
      setTimeout(updateIndex, 100);

      // Update on every slide transition.
      UIkit.util.on(sliderEl, 'itemshown', updateIndex);
    });

    // -----------------------------------------------------------------
    // Slick gallery + content carousels (legacy)
    // -----------------------------------------------------------------
    $('.fc-wrapper-legacy .legacy-gallery-carousel').each(function () {
      var $this = $(this);
      var slidesToShow = parseInt($this.data('slides-to-show'), 10) || 3;
      $this.slick({
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: Math.min(slidesToShow, 2) } },
          { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
      });
    });

    // SimpleLightbox for legacy galleries
    $('.fc-wrapper-legacy .legacy-gallery').each(function () {
      var $links = $(this).find('[data-lightbox="legacy-gallery"]').filter(function () {
        return !$(this).closest('.slick-cloned').length;
      });
      if ($links.length) {
        new SimpleLightbox($links.get());
      }
    });

    // Slick clones — route cloned-anchor clicks to the original so the
    // lightbox still opens.
    $('.fc-wrapper-legacy .legacy-gallery').on('click', '.slick-cloned [data-lightbox="legacy-gallery"]', function (e) {
      e.preventDefault();
      var href = this.getAttribute('href');
      var $original = $(this).closest('.legacy-gallery')
        .find('.slick-slide:not(.slick-cloned) [data-lightbox="legacy-gallery"]')
        .filter(function () { return this.getAttribute('href') === href; })
        .first();
      if ($original.length) $original.get(0).click();
    });

    // -----------------------------------------------------------------
    // Countdown (legacy)
    // -----------------------------------------------------------------
    document.querySelectorAll('.fc-wrapper-legacy .legacy-countdown[data-countdown]').forEach(function (el) {
      var targetStr = el.getAttribute('data-countdown');
      if (!targetStr) return;

      var targetDate = new Date(targetStr.replace(' ', 'T'));
      if (isNaN(targetDate.getTime())) return;

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var diff = targetDate - new Date();

        if (diff <= 0) {
          var units = el.querySelector('.legacy-countdown-units');
          var expired = el.querySelector('.legacy-countdown-expired');
          if (units) units.style.display = 'none';
          if (expired) expired.style.display = '';
          return;
        }

        var d = el.querySelector('[data-unit="days"]');
        var h = el.querySelector('[data-unit="hours"]');
        var m = el.querySelector('[data-unit="minutes"]');
        var s = el.querySelector('[data-unit="seconds"]');
        if (d) d.textContent = pad(Math.floor(diff / 86400000));
        if (h) h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        if (m) m.textContent = pad(Math.floor((diff % 3600000) / 60000));
        if (s) s.textContent = pad(Math.floor((diff % 60000) / 1000));
      }

      tick();
      setInterval(tick, 1000);
    });

    // -----------------------------------------------------------------
    // Panel display visualizer (legacy)
    // -----------------------------------------------------------------
    document.querySelectorAll('.fc-wrapper-legacy .legacy-panel-visualizer').forEach(function (block) {
      var $options = $(block).find('.panel-options li');
      var $images = $(block).find('.panel-image');

      $options.on('click', function () {
        var key = $(this).data('panel-key');
        if (!key) return;

        $options.removeClass('active');
        $(this).addClass('active');

        $images.removeClass('active');
        $images.filter('[data-panel-key="' + key + '"]').addClass('active');
      });

      if (!$options.filter('.active').length) {
        $options.first().addClass('active');
        $images.first().addClass('active');
      }
    });
  });
})(jQuery);
